import React from "react";

import { cn } from "~/lib/ui/utils/utils";

type RowProps = React.ComponentProps<"div"> & {
  children: React.ReactNode;
};

export function Row({ children, className, ref, ...rest }: RowProps) {
  return (
    <div className={cn("flex flex-row", className)} ref={ref} {...rest}>
      {children}
    </div>
  );
}
